const positions = [
  {
    company: 'Eucalyptus / Hims & Hers',
    position: 'Data Science Lead',
    link: 'https://www.eucalyptus.health',
    daterange: 'May 2026 - Present',
    roledescription: 'Leading applied ML and data science across multiple brands and 5 markets (AU, UK, ES, DE, JP).',
    points: [
      'Own CRM decisioning: who we contact, when, and with what.',
      'Build churn models feeding retention KPIs, and upsell models driving monetisation.',
      'Define the experimentation framework and ML decisioning approach.',
      'Set the data science roadmap and deliver it end to end, using agentic AI to run multiple workstreams in parallel.',
    ],
  },
  {
    company: 'Checkout.com',
    position: 'Senior Data Scientist',
    link: 'https://www.checkout.com',
    daterange: 'November 2024 - May 2026',
    roledescription: 'First data scientist covering end-to-end funds flow at Checkout.com, a global payments processor.',
    points: [
      'Defined north star metrics and net revenue targets, and shaped cost optimisation initiatives, for the Financial Experiences pillar — a cross-functional team of 50+ engineers and PMs overseeing all funds flow through the platform.',
      'Enabled the launch of a new product distributing over US$100m daily by modelling liquidity, the cost base across global jurisdictions, and future revenue.',
      'Led rapid-response analytics and controls for EU/UK/MENA/US regulatory compliance, supporting global expansion and new operating licences.',
    ],
  },
  {
    company: 'The Entire History of Us',
    position: 'Founder',
    link: 'https://entirehistoryofus.com',
    daterange: 'May 2024 - Present',
    points: [
      [
        'Built a ',
        { text: 'reusable agentic LLM engine', link: 'https://github.com/LeooDong/universe_builder' },
        ' in tested Python (pytest, CI) that generates and cross-links a 40,000-record historical corpus for a Flutter iOS timeline app (public TestFlight beta).',
      ],
      'Designed its LLM evaluation framework (schema checks, tiered LLM-as-judge, significance-tested prompt A/B tests), holding wrong-subject records to 0.25% on a 7,900-record batch.',
    ],
  },
  {
    company: 'Sainsbury\'s',
    position: 'Data Scientist (Machine Learning Engineering)',
    link: 'https://www.sainsburys.co.uk',
    daterange: 'December 2021 - November 2024',
    roledescription: 'Built customer models and MLOps pipelines for one of the UK’s largest supermarket and retail groups.',
    points: [
      'Increased Google Ads return on advertising spend (ROAS) by 200%+ and conversion value by 150% using propensity models to target high-potential-value customers.',
      'Designed and implemented a Docker-based ML scoring pipeline that brought model scoring in-house, reducing third-party costs and increasing internal model adoption.',
      'Collaborated with analysts and SMEs to create a first-of-its-kind, holistic, customer-level view of promotional spending, now used across all marketing to inform strategic decisions.',
    ],
  },
  {
    company: 'X15 Ventures',
    position: 'Lead Data Scientist',
    link: 'https://www.x15ventures.com.au',
    daterange: 'November 2020 - November 2021',
    roledescription: 'Led data science strategy across a portfolio of fintech start-ups.',
    points: [
      'Led data science strategy for Vonto, a B2B small business analytics start-up, directing the product build and running A/B tests that lifted conversion by 11%.',
      'Consulted on personalisation methodology for the initial build of its core recommendation system as part of the founding team of Cheddar, an AI-powered deal discovery app co-developed with BCG Digital Ventures.',
    ],
  },
  {
    company: 'University of Technology Sydney',
    position: 'Academic Supervisor',
    link: 'https://www.uts.edu.au',
    daterange: 'August 2020 - November 2021',
    roledescription: 'Supervised industry projects and coursework for the Master of Data Science and Innovation programme.',
    points: [
      'Guided master\'s students through delivering industry-sponsored projects, such as water chemical monitoring models for Sydney Water, and marked submissions.',
    ],
  },
  {
    company: 'Commonwealth Bank of Australia',
    position: 'Data Scientist',
    link: 'https://www.commbank.com.au',
    daterange: 'December 2017 - November 2020',
    roledescription: 'Delivered projects within a data science team, using statistics and machine learning to build (end to end) and consult on bespoke, customer focused products at Australia\'s largest financial institution.',
    points: [
      'Co-built and deployed Bill Sense, a customer-facing app feature predicting bill amount, frequency and recurrence for over 7 million customers, and notifying them when their bill pricing changed.',
      'Defined the eligibility matching that connected customers to government rebates, unlocking A$500m+ for customers; the team won the 2019 Gartner Eye on Innovation Award.',
      'Built economic forecasts from longitudinal customer data for the Australian Federal Cabinet during the COVID-19 pandemic.',
    ],
  },
  {
    company: 'Commonwealth Bank of Australia',
    position: 'Analyst',
    link: 'https://www.commbank.com.au',
    daterange: 'November 2015 - June 2016 | February 2017 - December 2017',
    roledescription: 'Provided analytics for the strategic sourcing and performance management centres of excellence.',
    points: [
      'Analysed trends in technology usage and contingent employee costs.',
      'Supported master services agreement negotiations with enterprise IT providers.',
    ],
  },
  {
    company: 'icourts',
    position: 'Paralegal',
    link: 'https://www.icourts.com.au',
    daterange: 'August 2015 - November 2015',
    roledescription: 'Managed evidence and submissions for the Royal Commission into Institutional Responses to Child Sexual Abuse.',
    points: [],
  },
];
export default positions;
